import Home from "../pages/home/Home";
import { Route } from "react-router-dom";
import AllModels from "../pages/utility-vehicles/allModels";
import OneThousandEFIModel from "../pages/utility-vehicles/oneThousandEFIModel";
import OneThousandFiveHundredModelTwo from "../pages/utility-vehicles/oneThousandFiveHundredModelTwo";
import OneThousandFiveHundredModelThree from "../pages/utility-vehicles/OneThousandFiveHundredModelThree";
import OneThousandFiveHundredModelFour from "../pages/utility-vehicles/OneThousandFiveHundredModelFour";
import TuDcOneModelFour from "../pages/utility-vehicles/TuDcOneModelFour";
import TuDcOneModelFive from "../pages/utility-vehicles/TuDcOneModelFive";
import Attachment from "../pages/utility-vehicles/attachments";
import Defend from "../pages/industries/defend";
import { AboutPage, AboutPage as GBAboutPage } from "../pages/about/AboutPage";
import ServiceAndSupport from "../pages/serviceAndSupport/serviceAndSupport";
import { Model } from "../pages/models/ModelPage";
import { Detail1500E } from "../pages/detail/detail1500E";
import { Detail1000EFI } from "../pages/detail/detail1000EFI";
import { Accessories } from "../pages/accessories/AccessoriesPage";
import { Dealers } from "../pages/dealers/DealersPage";
import { Service } from "../pages/service/ServicePage";
import { Contact } from "../pages/contact/ContactPage";
import HomePage from "../pages/newZealand/home/homePage";
import AtvAccessories from "../pages/newZealand/AtvAccessories/AtvAccessories";
import NzAbout from "../pages/newZealand/NzAbout/NzAbout";
import NzPetrol from "../pages/newZealand/NzPetrol/NzPetrol";
import NzElectricAccessories from "../pages/newZealand/NzElectricAccessories/NzElectricAccessories";
import NzOrchardised from "../pages/newZealand/NzOrchardised/NzOrchardised";
import NzElectricDualMotor from "../pages/newZealand/NzElectricDualMotor/NzElectricDualMotor";
import NZGallery from "../pages/newZealand/NZGallery/NZGallery";
import NZContactUs from "../pages/newZealand/NZContactUs/NZContactUs";

export const RouterPaths = {
  Home: "/us",
  UtilityVehicles: "/us/utility-vehicles",
  EFI: "/us/1000EFI",
  TU1500E2: "/us/tu-1500e-2",
  TU1500E3: "/us/tu-1500e-3",
  // TU1500E4: "/us/tu-1500e-4",
  TUDC2500E1: "/us/tu-DC2500E-1",
  TUSC2500E1: "/us/tu-SC2500E-1",
  Attachments: "/us/attachments",
  Defend: "/us/defend",
  About: "/us/about",
  ServicesAndSupport: "/us/warrnty",
  Blog: "/us/blog",
  BecomeADealer: "/us/become-a-dealer",
};

export const NZRouterPaths = {
  Home: "/nz",
  AtvAccessories: "/nz/Atv-Accessories",
  About: "/nz/about",
  Petrol: "/nz/petrol",
  ElectricAccessories: "/nz/electric-Accessories",
  Orchardised: "/nz/Orchardised",
  ElectricDualMotor: "/nz/electric-Dual-Motor",
  Gallery: "/nz/Gallery",
  ContactUs: "/nz/ContactUs",
  Blog: "/nz/blog",
};

export const LandingPageRoute = [
  {
    name: "Home",
    path: RouterPaths.Home,
    Routes: <Route path={RouterPaths.Home} element={<Home />} />,
  },
  {
    name: "utility-vehicles",
    path: RouterPaths.UtilityVehicles,
    Routes: (
      <Route path={RouterPaths.UtilityVehicles} element={<AllModels />} />
    ),
  },
  {
    name: "1000EFI",
    path: RouterPaths.EFI,
    Routes: <Route path={RouterPaths.EFI} element={<OneThousandEFIModel />} />,
  },
  {
    name: "tu-1500e-2",
    path: RouterPaths.TU1500E2,
    Routes: (
      <Route
        path={RouterPaths.TU1500E2}
        element={<OneThousandFiveHundredModelTwo />}
      />
    ),
  },
  {
    name: "tu-1500e-3",
    path: RouterPaths.TU1500E3,
    Routes: (
      <Route
        path={RouterPaths.TU1500E3}
        element={<OneThousandFiveHundredModelThree />}
      />
    ),
  },
  // {
  //   name: "tu-1500e-4",
  //   path: RouterPaths.TU1500E4,
  //   Routes: (
  //     <Route
  //       path={RouterPaths.TU1500E4}
  //       element={<OneThousandFiveHundredModelFour />}
  //     />
  //   ),
  // },
  {
    name: "tu-DC2500E-1",
    path: RouterPaths.TUDC2500E1,
    Routes: (
      <Route path={RouterPaths.TUDC2500E1} element={<TuDcOneModelFour />} />
    ),
  },
  {
    name: "tu-SC2500E-1",
    path: RouterPaths.TUSC2500E1,
    Routes: (
      <Route path={RouterPaths.TUSC2500E1} element={<TuDcOneModelFive />} />
    ),
  },
  {
    name: "attachments",
    path: RouterPaths.Attachments,
    Routes: <Route path={RouterPaths.Attachments} element={<Attachment />} />,
  },
  {
    name: "defend",
    path: RouterPaths.Defend,
    Routes: <Route path={RouterPaths.Defend} element={<Defend />} />,
  },
  {
    name: "about",
    path: RouterPaths.About,
    Routes: <Route path={RouterPaths.About} element={<GBAboutPage />} />,
  },
  {
    name: "services-and-support",
    path: RouterPaths.ServicesAndSupport,
    Routes: (
      <Route
        path={RouterPaths.ServicesAndSupport}
        element={<ServiceAndSupport />}
      />
    ),
  },
];

// Landing Page New Zealand
export const LandingPageNZRoute = [
  {
    name: "Home",
    path: NZRouterPaths.Home,
    Routes: <Route path={NZRouterPaths.Home} element={<HomePage />} />,
  },
  {
    name: "Atv-Accessories",
    path: NZRouterPaths.AtvAccessories,
    Routes: (
      <Route path={NZRouterPaths.AtvAccessories} element={<AtvAccessories />} />
    ),
  },
  {
    name: "Petrol",
    path: NZRouterPaths.Petrol,
    Routes: <Route path={NZRouterPaths.Petrol} element={<NzPetrol />} />,
  },
  {
    name: "ElectricAccessories",
    path: NZRouterPaths.ElectricAccessories,
    Routes: (
      <Route
        path={NZRouterPaths.ElectricAccessories}
        element={<NzElectricAccessories />}
      />
    ),
  },
  {
    name: "About",
    path: NZRouterPaths.About,
    Routes: <Route path={NZRouterPaths.About} element={<NzAbout />} />,
  },
  {
    name: "Orchardised",
    path: NZRouterPaths.Orchardised,
    Routes: (
      <Route path={NZRouterPaths.Orchardised} element={<NzOrchardised />} />
    ),
  },
  {
    name: "ElectricDualMotor",
    path: NZRouterPaths.ElectricDualMotor,
    Routes: (
      <Route
        path={NZRouterPaths.ElectricDualMotor}
        element={<NzElectricDualMotor />}
      />
    ),
  },
  {
    name: "Gallery",
    path: NZRouterPaths.Gallery,
    Routes: <Route path={NZRouterPaths.Gallery} element={<NZGallery />} />,
  },
  {
    name: "ContactUs",
    path: NZRouterPaths.ContactUs,
    Routes: <Route path={NZRouterPaths.ContactUs} element={<NZContactUs />} />,
  },
];
